import { ApiConfig, BackendConfig } from '@eng-dx-gpt/api-client';
import { knowledgeBaseBackendConfig } from '@eng-dx-gpt/knowledge-base/config';
import { uiManagerBackendConfig } from '@eng-dx-gpt/ui-manager/config';
import { virtualAssistantBackendConfig } from '@eng-dx-gpt/virtual-assistant/config';

/**
 * Aggregated backend configuration from all microservices
 *
 * Note: Importing from /config paths is allowed as these are separate entry points
 * that don't include the full library code, maintaining lazy-loading benefits.
 * The actual library code is still lazy-loaded via Angular routes.
 */
const backendApi: ApiConfig[] = [
    ...knowledgeBaseBackendConfig,
    ...virtualAssistantBackendConfig,
    ...uiManagerBackendConfig
];

export const backendConfig: Partial<BackendConfig> = {
    api: backendApi
};
